export default "__VITE_ASSET__DhLM1BPJ__"